import React, { useState, useEffect } from "react";
import { Filter } from "lucide-react";
import "./Portfolio.css";

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState("Tous");
  const [filteredServices, setFilteredServices] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //Photo page portfolio
const services = [
  {
    category: 'Peinture',
    images: [
      { url: '/images/peinture1.jpg', alt: 'Peinture 1' },
      { url: '/images/peinture2.jpg', alt: 'Peinture 2' }
    ]
  },
  {
    category: 'Pose d\'argile',
    images: [
      { url: '/images/argile1.jpg', alt: 'Argile 1' },
      { url: '/images/argile2.jpg', alt: 'Argile 2' },
      { url: '/images/argile3.jpg', alt: 'Argile 3' },
      { url: '/images/argile4.jpg', alt: 'Argile 4' }
    ]
  },
  {
    category: 'Parquet',
    images: [
      { url: '/images/parquet1.jpg', alt: 'Parquet 1' },
      { url: '/images/parquet2.jpg', alt: 'Parquet 2' }
    ]
  },
  {
    category: 'Claustra',
    images: [
      { url: '/images/claustra1.jpg', alt: 'Claustra 1' },
      { url: '/images/claustra2.jpg', alt: 'Claustra 2' }
    ]
  },
  {
    category: 'Plaque de plâtre',
    images: [
      { url: '/images/platre1.jpg', alt: 'Plaque de plâtre 1' },
      { url: '/images/platre2.jpg', alt: 'Plaque de plâtre 2' }
    ]
  },
  {
    category: 'Enduit',
    images: [
      { url: '/images/enduit1.jpg', alt: 'Enduit 1' },
      { url: '/images/enduit2.jpg', alt: 'Enduit 2' }
    ]
  },
  {
    category: 'Faux plafond',
    images: [
      { url: '/images/faux-plafond.jpg', alt: 'Faux plafond' }
    ]
  },
  {
    category: 'Cloison',
    images: [
      { url: '/images/cloison1.jpg', alt: 'Cloison 1' },
      { url: '/images/cloison2.jpg', alt: 'Cloison 2' }
    ]
  },
  {
    category: 'Contre cloison',
    images: [
      { url: '/images/contre-cloison.jpg', alt: 'Contre cloison' }
    ]
  },
  {
    category: 'Pool house',
    images: [
      { url: '/images/pool-house.jpg', alt: 'Pool house' }
    ]
  }
];

  const categories = ["Tous", ...services.map((s) => s.category)];

  useEffect(() => {
    if (activeFilter === "Tous") {
      setFilteredServices(services);
    } else {
      setFilteredServices(services.filter((s) => s.category === activeFilter));
    }
   
  }, [activeFilter]);

  return (
    <div className="portfolio-page">
      {/* Header */}
      <section className="portfolio-header">
        <div className="container">
          <h1 className="fade-in">Portfolio</h1>
          <div className="header-underline"></div>
          <p className="fade-in">
            Découvrez nos réalisations et notre savoir-faire
          </p>
        </div>
      </section>

      {/* Filtre */}
      <section className="filter-section">
        <div className="container">
          <div className="filter-header">
            <Filter size={20} />
            <span>Filtrer par service</span>
          </div>
          <div className="filter-buttons">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-btn ${
                  activeFilter === category ? "active" : ""
                }`}
                onClick={() => setActiveFilter(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Galerie */}
      <section className="gallery-section">
        <div className="container">
          {filteredServices.map((service, serviceIndex) => (
            <div key={serviceIndex} className="service-gallery fade-in">
              <h2 className="service-title">{service.category}</h2>
              <div className="images-grid">
                {service.images.map((image, imageIndex) => (
                  <div
                    key={imageIndex}
                    className="gallery-item scale-in"
                    style={{ animationDelay: `${imageIndex * 0.1}s` }}
                  >
                    <img src={image.url} alt={image.alt} />
                    <div className="gallery-overlay">
                      <span>{service.category}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
 